// extracted by mini-css-extract-plugin
export var iconContainer = "index-module--iconContainer--9mSCf";
export var imgFooter = "index-module--imgFooter--FwS90";
export var spacer = "index-module--spacer--BF2Tf";